/* @flow */

import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { DEFAULT_BLOCK_ICON } from 'edito/constants';

type Props = {
  template: EditorialBlockTemplate,
  onSelect: (type: EditorialBlockType) => void,
};

const BlockTypeCard = ({ template, onSelect }: Props) => {
  const select = () => onSelect(template.code);

  return (
    <Card raised centered color="blue" onClick={select}>
      <Card.Content>
        <h2 className="ui center aligned icon header">
          <Icon name={template.icon || DEFAULT_BLOCK_ICON} />
          {template.label}
        </h2>
      </Card.Content>
    </Card>
  );
};

export default BlockTypeCard;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlockTypeCard.js